import { versionAtLeast } from "../helpers/versions";
export var CommandType;
(function (CommandType) {
    CommandType["tellraw"] = "tellraw";
    CommandType["overlay"] = "overlay";
    CommandType["sign"] = "sign";
    CommandType["book"] = "book";
    CommandType["hovertext"] = "hovertext";
    CommandType["children"] = "children";
})(CommandType || (CommandType = {}));
export var FeatureType;
(function (FeatureType) {
    FeatureType[FeatureType["clicking"] = 0] = "clicking";
    FeatureType[FeatureType["hovering"] = 1] = "hovering";
    FeatureType[FeatureType["insertion"] = 2] = "insertion";
    FeatureType[FeatureType["pages"] = 3] = "pages";
    FeatureType[FeatureType["bookPreview"] = 4] = "bookPreview";
    FeatureType[FeatureType["font"] = 5] = "font";
    FeatureType[FeatureType["customColor"] = 6] = "customColor";
    FeatureType[FeatureType["nbtComponent"] = 7] = "nbtComponent";
    FeatureType[FeatureType["nbtStorageComponent"] = 8] = "nbtStorageComponent";
})(FeatureType || (FeatureType = {}));
/**
 * Indicates true or false, whether a given feature is
 * available for a specific type of command
 *
 * For example, hovering over text is not available
 * in sign commands
 *
 * @param commandType The command type
 * @param feature  The feature being queried
 */
export function isFeatureAvailable(commandType, version, feature) {
    // console.log(`Checking feature: ${FeatureType[feature]} for version ${version}, command type ${commandType}`)
    if (feature == FeatureType.clicking) {
        if (commandType == CommandType.tellraw ||
            commandType == CommandType.book ||
            commandType == CommandType.sign) {
            return true;
        }
        else {
            return false;
        }
    }
    else if (feature == FeatureType.hovering ||
        feature == FeatureType.insertion) {
        // Clicking, hovering, and inserting are all the same
        // They are supported by tellraw and books
        // but nothing else
        if (commandType == CommandType.tellraw ||
            commandType == CommandType.book) {
            return true;
        }
        else {
            return false;
        }
    }
    else if (feature == FeatureType.pages ||
        feature == FeatureType.bookPreview) {
        // Pages & book previews are supported by books only
        return commandType == CommandType.book;
    }
    else if (feature == FeatureType.font || feature == FeatureType.customColor) {
        return versionAtLeast(version, "1.16");
    }
    else if (feature == FeatureType.nbtComponent) {
        return versionAtLeast(version, "1.14");
    }
    else if (feature == FeatureType.nbtStorageComponent) {
        return versionAtLeast(version, "1.15");
    }
    else {
        return true;
    }
}
export function template_lookup(ct) {
    return templates[CommandType[ct]];
}
const templates = {
    "tellraw": [
        "/tellraw @p %s",
        "/execute @a ~ ~ ~ tellraw @p %s"
    ],
    "overlay": [
        "/title @a title %s",
        "/title @a subtitle %s",
        "/title @a actionbar %s"
    ],
    "sign": [
        "/give @p oak_sign{BlockEntityTag:{%s,id:\"Sign\"}}",
        "/data merge block [x] [y] [z] {%s}"
    ],
    "book": [
        "/give @p written_book{pages:%s,title:\"Custom Book\",author:Player}"
    ]
};
